import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'


function RedirectURL({ server }) {
    const params = useParams()
    const [creator, setCreator] = useState('')
    const [error, setError] = useState('')
    useEffect(() => {
        fetch(server + '/id/' + params.url).then(res => res.json()).then(data => {
            console.log(data)
            if (data.error) {
                setError(data.error)
            } else if (data.result.error) {
                setError(data.result.error.message)
            } else {
                let link = data.result.items[0].id.videoId
                setCreator(data.result.items[0].snippet.channelTitle)
                window.location = 'https://www.youtube.com/watch?v=' + link
            }
        })
        //eslint-disable-next-line
    }, [params])

    return (
        <div>
            {error === "" ?
                <>
                    Redirecting to {creator !== "" ? creator : 'a'} youtube video
                </> : error}
        </div>
    )
}

export default RedirectURL